//Función para formatear la hora al formato "09:57".
export const  formatHourAlt = (inputDate) => {
    const date = new Date(inputDate);
    const options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'UTC'
    };
    const formattedDate = date.toLocaleString('en-US', options);
    return formattedDate;
};

